<template>
  <div class="page-content">
    <div class="contenter">
      <div class="left-content">
        <tree-components
          ref="leaseTree"
          :treeList='leaseList'
          :defaultProps='leaseProps'
          :activeNode='activeLease'
          @handleNodeChange='handleLeaseChange'
          @handleGetTreeList='handleGetLeaseList'
          >
        </tree-components>
      </div>
      <div class="right-content">
        <company-info
          ref="companyInfo"
          :companyName='companyName'
          :tel='tel'
        >
        </company-info>
        <div class="main">
          <div class="switch-tree">
            <tree-components
              ref="treeComponents"
              :showSearch='false'
              :treeList='treeList'
              :defaultProps='defaultProps'
              :activeNode='activeNode'
              @handleNodeChange='handleNodeChange'
              @handleGetTreeList='handleGetTreeList'
              >
            </tree-components>
          </div>
          <div class="main-content">
            <div class="top-content">
              <p class="title">{{ this.activeNodeName }}</p>
              <div class="card">
                <el-row :gutter="8">
                  <el-col :span="4" v-for="item in switchList" :key="item.id">
                    <el-card class="card-item" shadow="hover">
                      <div class="card-content">
                        <p class="title">{{ item.name }}</p>
                        <el-button class="btn" type="primary" size="small" v-if="item.status === 0" @click="handleSwitchOnOff(item)" >开</el-button>
                        <el-button class="btn" size="small" v-if="item.status === 1" @click="handleSwitchOnOff(item)" >关</el-button>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="bottom-content">
              <p class="title">操作日志</p>
              <div class="search">
                <el-form :inline="true" :model="filters" size="small" @keyup.enter.native="handleGetData">
                  <!-- <el-form-item label="时间类型">
                    <el-select v-model="filters.timeType" @change="handleTimeTypeChange" style="width: 100px" placeholder="请选择">
                      <el-option :value="0" label="日"></el-option>
                      <el-option :value="1" label="周"></el-option>
                      <el-option :value="2" label="月"></el-option>
                      <el-option :value="3" label="时间段"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item >
                    <el-date-picker v-if="filters.timeType === 0" v-model="filters.time" type="date" style="width: 160px" key="day" placeholder="选择日期"></el-date-picker>
                    <el-date-picker v-if="filters.timeType === 1" v-model="filters.time" type="week" format="yyyy 第 WW 周" key="week" style="width: 160px" placeholder="选择日期"></el-date-picker>
                    <el-date-picker v-if="filters.timeType === 2" v-model="filters.time" type="month" style="width: 160px" key="month" placeholder="选择日期"></el-date-picker>
                    <el-date-picker v-if="filters.timeType === 3" v-model="filters.daterange" type="daterange" key="daterange" style="width: 280px" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleGetData">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleExport">导出</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="table-content">
                <el-table id="table" ref="table" class="simple-table" :data="tableData" size='small' max-height="300px" highlight-current-row fit border >
                  <el-table-column v-for="column in columns" header-align="center" :align="column.align?column.align:'center'"
                    :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
                    :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter" show-overflow-tooltip>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import Socket from '@/utils/websocket'
import { exportExcel } from '@/utils/index.js'
import treeComponents from './components/treeComponents.vue'
import companyInfo from './components/companyInfo.vue'
export default {
  name: 'switchControl',
  components: {
    treeComponents,
    companyInfo
  },
  data () {
    return {
      filters: {
        timeType: 0,
        time: new Date(),
        daterange: [new Date(), new Date()]
      },
      webSocket: null,
      webSocketOptions: {
        ip: '',
        key: '',
        path: '',
        port: ''
      },
      companyName: '',
      tel: '',
      activeLease: '',
      leaseList: [],
      leaseProps: {
        children: 'children',
        label: 'name'
      },
      activeNode: '',
      activeNodeName: '',
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      activeSwitch: '',
      activeSwitchName: '',
      switchList: [],
      switchInfo: [],
      columns: [
        { prop: 'measureName', label: '开关', minWidth: 100 },
        { prop: 'command', label: '状态', minWidth: 100 },
        { prop: 'userNickname', label: '操作人', minWidth: 100 },
        { prop: 'time', label: '变更时间', minWidth: 100 }
      ],
      tableData: []
    }
  },
  created () {
    this.handleGetCompanyInfo()
    // this.handleGetTreeList()
    this.handleGetLeaseList()
  },
  methods: {
    handleGetWebsocketUrl () {
      this.$api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        if (res.success) {
          this.webSocketOptions = Object.assign({}, res.data)
          this.handleWebsocketInit()
        }
      })
    },
    handleWebsocketInit () {
      if (this.webSocket !== null) {
        console.log('webSocket.close')
        this.webSocket.close()
      }
      let result = {}
      this.webSocket = new Socket({
        url: window.baseConfig.wsAgreement + '://' + this.webSocketOptions.ip + ':' + this.webSocketOptions.port + '/' + this.webSocketOptions.path
      })
      this.webSocket.onopen(() => {
        console.log(this.webSocketOptions.key)
        this.webSocket.send({
          methodCode: '101',
          key: this.webSocketOptions.key
        })
      })
      this.webSocket.onmessage((res) => {
        result = Object.assign({}, JSON.parse(res))
        try {
          for (let i = 0; i < this.switchList.length; i++) {
            for (let j = 0; j < result.data.length; j++) {
              if (this.switchList[i].id === result.data[j].measureId) {
                this.switchList[i].status = parseInt(result.data[j].data[0].value)
              }
            }
          }
        } catch (error) {
          console.log(error)
        }
        console.log(this.switchList)
        this.handdleWebSocketOnmessage(result)
      })
    },
    handdleWebSocketOnmessage (res) {
      if (res.methodCode === '102') {
        let requsetInfo = this.switchList.map((item) => {
          return {
            id: item.id,
            points: [
              { code: 601, number: 0 }
            ]
          }
        })
        this.webSocket.send({
          methodCode: '103',
          measures: requsetInfo
        })
      }
    },
    handleGetCompanyInfo () {
      this.$api.company.getCompanyInfo().then((res) => {
        if (res.success) {
          this.companyName = res.data.name
          this.tel = res.data.contactPhoneNumber
        }
      })
    },
    handleLeaseChange (data) {
      this.activeLease = data.id
      this.$nextTick(() => {
        this.$refs['leaseTree'].handleSetCurrentKey(this.activeLease)
      })
      this.treeList = data.areas
      this.handleNodeChange(this.treeList[0])
    },
    handleNodeChange (data) {
      this.activeNode = data.id
      this.activeNodeName = data.name
      this.$nextTick(() => {
        this.$refs['treeComponents'].handleSetCurrentKey(this.activeNode)
      })
      // this.dataList = this.handleGetAllLeaf([data])
      this.handleGetRoomSwitches()
      // this.handleGetData()
    },
    handleGetLeaseList () {
      this.leaseList = []
      this.$api.rentalArea.getLeaseContractForProperty(0, -1, [], '', '', '', '', 1).then((res) => {
        if (res.success) {
          this.leaseList = res.data.map((item) => {
            return {
              ...item,
              name: item.lesseeTransactorNickname
            }
          })
          this.handleLeaseChange(this.leaseList[0])
        }
      })
    },
    handleGetRoomSwitches () {
      this.switchList = []
      this.$api.rentalArea.getRentalAreaSwitches(this.activeNode).then((res) => {
        if (res.success) {
          console.log(res)
          this.switchList = res.data.map((item) => {
            return {
              ...item,
              status: 0
            }
          })
          this.handleGetData()
          this.handleGetWebsocketUrl()
        }
      })
    },
    handleGetData () {
      this.tableData = []
      // let startTime = ''
      // let endTime = ''
      // switch (this.filters.timeType) {
      //   case 0:
      //     startTime = this.$moment(this.filters.time).startOf('d').format('yyyy/MM/DD HH:mm:ss')
      //     endTime = this.$moment(this.filters.time).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
      //     break
      //   case 1:
      //     startTime = this.$moment(this.filters.time).startOf('week').format('yyyy/MM/DD HH:mm:ss')
      //     endTime = this.$moment(this.filters.time).endOf('week').add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
      //     break
      //   case 2:
      //     startTime = this.$moment(this.filters.time).startOf('month').format('yyyy/MM/DD HH:mm:ss')
      //     endTime = this.$moment(this.filters.time).add(1, 'M').startOf('month').format('yyyy/MM/DD HH:mm:ss')
      //     break
      //   case 3:
      //     startTime = this.$moment(this.filters.daterange[0]).startOf('d').format('yyyy/MM/DD HH:mm:ss')
      //     endTime = this.$moment(this.filters.daterange[1]).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
      //     break
      // }
      let requestList = this.switchList.map((item) => {
        return this.$api.command.getRecentHistoryOfMeasureCommandExecuting(item.id, null)
        // return this.$api.command.getRecentHistoryOfMeasureCommandExecuting('10504244002381836', null)
      })
      Promise.all(requestList).then((res) => {
        if (res[0].success) {
          res.forEach((item) => {
            this.tableData = this.tableData.concat(item.data)
          })
          console.log('tableData', this.tableData)
        }
      })
    },
    handleSwitchOnOff: debounce(function (sw) {
      let onOff = sw.status === 0 ? 'ON' : 'OFF'
      this.$api.command.executeCommandOnMeasure(sw.id, 'Switch', [{ 'ON-OFF': onOff }]).then((res) => {
        if (res.success) {
          console.log(res)
        }
      })
    }, 800, { 'leading': true, 'trailing': false }),
    handleExport () {
      let selectedDate = {
        dateType: 'day',
        startTime: new Date(),
        endTime: new Date()
      }
      exportExcel('table', '操作日志', selectedDate)
    }
  },
  beforeDestroy () {
    if (this.webSocket !== null) {
      this.webSocket.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: #333;
  padding: 16px;
  .contenter {
    width: 100%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    .left-content {
      width: 240px;
      height: 100%;
      // border: 1px solid;
      box-sizing: border-box;
    }
    .right-content {
      text-align: left;
      // display: flex;
      margin-left: 16px;
      width: calc(100% - 256px);
      height: 100%;
      // border: 1px solid;
      box-sizing: border-box;
      .main {
        display: flex;
        width: 100%;
        height: calc(100% - 160px);
        // border: 1px solid;
        .switch-tree {
          margin-right: 12px;
          box-sizing: border-box;
          width: 200px;
          height: 100%;
          overflow: auto;
        }
        .main-content {
          padding: 8px;
          width: calc(100% - 212px);
          height: 100%;
          overflow: auto;
          box-sizing: border-box;
          .top-content {
            margin-bottom: 12px;
            width: 100%;
            // height: 300px;
            // overflow: auto;
            box-sizing: border-box;
            .card {
              width: 100%;
              max-height: 200px;
              // overflow: auto;
            }
          }
          .title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 12px;
          }
          .card-content {
            text-align: center;
            .title {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
